import * as React from "react"
import { toPersianDigits } from "utils"
import { Link } from "react-router-dom"
import "./pagination.scss"

interface Pagination {
	totalItems: number
	perPage: number
	currentPage: number
	link: string
	className?: string
	onClick?(page: number): void
}

const Pagination: React.FC<Pagination> = ({
	totalItems,
	perPage,
	currentPage,
	link,
	onClick,
	className = "",
}) => {
	const totalPages = Math.ceil(totalItems / perPage)

	return (
		<ul className={`p-0 ${className}`}>
			{[...Array(totalPages).keys()].map((item) => (
				<li
					key={item + 1}
					className={`pagination__li ${
						currentPage === item + 1 ? "pagination__li--active" : ""
					}`}
				>
					<Link
						className="pagination__link"
						to={`${link}/${item + 1}`}
						onClick={(event) => {
							if (onClick) {
								event.preventDefault()
								onClick(item + 1)
							}
						}}
					>
						{toPersianDigits(item + 1)}
					</Link>
				</li>
			))}
		</ul>
	)
}

export default Pagination
